import React from "react";
import {
  FeatureItem,
  IconBox,
  PlanCard,
  PlanPrice,
  PlanPriceBox,
  PlanTitle,
  PlanTitleBox,
  PricingHelperText,
  TitlePriceWrapper,
  RadioButtonChecked,
  PriceAdditionalInfoBox,
  PlanPriceTextRow,
  PlanPriceText
} from "./SubscriptionPlanCard.styled";
import { Box, CardContent } from "@mui/material";

export interface SubscriptionPlanProps {
  title: string;
  price: string;
  color?: string;
  helperText?: string;
  isSelected?: boolean;
  description: string;
  tabIndex?: number;
  taxRate?: number;
  taxInclusivePrice?: string;
  translator?: any;
}

const SubscriptionPlanCard: React.FC<SubscriptionPlanProps> = (props) => {
  const {
    title,
    price,
    color,
    helperText,
    isSelected = false,
    description,
    tabIndex = 0,
    taxRate = 21,
    taxInclusivePrice,
    translator
  } = props;

  return (
    <PlanCard color={color} isSelected={isSelected}>
      <CardContent style={{ padding: 0 }}>
        <TitlePriceWrapper>
          <PlanTitleBox>
            <IconBox color={color} feature={false} isSelected={isSelected}>
              {isSelected ? <RadioButtonChecked /> : <></>}
            </IconBox>
            <PlanTitle component="span" style={{ marginLeft: 10 }}>
              {title}
            </PlanTitle>
          </PlanTitleBox>
          <PlanPriceBox>
            <PlanPriceTextRow>
              <PlanPrice>
                {tabIndex === 0 ? taxInclusivePrice : price}
              </PlanPrice>
              <PlanPriceText>
                {translator ? translator("titles.perMonth") : "/month"}
              </PlanPriceText>
            </PlanPriceTextRow>
            {tabIndex > 0 && (
              <PriceAdditionalInfoBox>
                {taxInclusivePrice}
                {translator ? translator("titles.perMonth") : "/month"}
              </PriceAdditionalInfoBox>
            )}
            <PriceAdditionalInfoBox>
              {translator
                ? translator("descriptions.includingPercentTaxRate", {
                    percent: taxRate
                  })
                : `including ${taxRate}% VAT`}
            </PriceAdditionalInfoBox>
          </PlanPriceBox>
        </TitlePriceWrapper>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          marginBottom={{ xs: "32px", sm: "65px" }}
        >
          <FeatureItem component="span">{description}</FeatureItem>
        </Box>
        <PricingHelperText>{helperText}</PricingHelperText>
      </CardContent>
    </PlanCard>
  );
};

export default SubscriptionPlanCard;
